import React from "react";
import { Link } from "react-router-dom";
import {
  FaRocket,
  FaCoins,
  FaHeadset,
  FaShieldAlt,
  FaUserCheck,
  FaArrowRight,
} from "react-icons/fa";

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <FaRocket />,
      title: "Easy Onboarding",
      description:
        "Get started in minutes with simple KYC and instant activation.",
    },
    {
      icon: <FaCoins />,
      title: "Best Commissions",
      description:
        "Earn up to 1% on AEPS and competitive rates on all services.",
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Support",
      description:
        "Dedicated support team available round the clock to assist you.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Bank-Grade Security",
      description: "All transactions are encrypted and fully secure.",
    },
    {
      icon: <FaUserCheck />,
      title: "Zero Hidden Fees",
      description:
        "No setup costs or annual charges – you only pay for what you use.",
    },
  ];

  return (
    <section style={styles.section}>
      <div className="container" style={styles.container}>
        {/* Section Header */}
        <div style={styles.header}>
          <span style={styles.subtitle}>Why Retailers Trust Us</span>
          <h2 style={styles.title}>
            Why <span style={styles.accent}>Retailers</span> Choose Us
          </h2>
          <p style={styles.description}>
            Join thousands of successful partners who have grown their business
            with Happy Pay Fintech.
          </p>
        </div>

        {/* Reasons Grid */}
        <div style={styles.grid}>
          {reasons.map((reason, idx) => (
            <div key={idx} style={styles.card}>
              <div style={styles.iconWrapper}>{reason.icon}</div>
              <h3 style={styles.cardTitle}>{reason.title}</h3>
              <p style={styles.cardDesc}>{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Inline styles – you can move these to a CSS file
const styles = {
  section: {
    backgroundColor: "#ffffff",
    padding: "80px 0",
    fontFamily: "'Inter', sans-serif",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  },
  header: {
    textAlign: "center",
    marginBottom: "60px",
  },
  subtitle: {
    display: "inline-block",
    backgroundColor: "#f39c1220",
    color: "#f39c12",
    fontWeight: "600",
    fontSize: "0.9rem",
    padding: "4px 16px",
    borderRadius: "30px",
    marginBottom: "16px",
  },
  title: {
    fontSize: "clamp(2rem, 4vw, 2.8rem)",
    fontWeight: "700",
    color: "#1e293b",
    marginBottom: "16px",
    lineHeight: "1.2",
  },
  accent: {
    color: "#f39c12",
  },
  description: {
    fontSize: "1.1rem",
    color: "#64748b",
    maxWidth: "600px",
    margin: "0 auto",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "30px",
    marginBottom: "50px",
  },
  card: {
    backgroundColor: "#f9fafc",
    borderRadius: "16px",
    padding: "30px 20px",
    textAlign: "center",
    transition: "all 0.3s ease",
    border: "1px solid #eef2f6",
    cursor: "default",
  },
  iconWrapper: {
    width: "70px",
    height: "70px",
    margin: "0 auto 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    borderRadius: "50%",
    boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
    color: "#f39c12",
    fontSize: "2rem",
  },
  cardTitle: {
    fontSize: "1.2rem",
    fontWeight: "600",
    color: "#1e293b",
    marginBottom: "12px",
  },
  cardDesc: {
    fontSize: "0.95rem",
    color: "#64748b",
    lineHeight: "1.6",
  },
  buttonWrapper: {
    textAlign: "center",
  },
  button: {
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "#f39c12",
    color: "#1e293b",
    fontWeight: "600",
    padding: "14px 36px",
    borderRadius: "50px",
    textDecoration: "none",
    fontSize: "1rem",
    transition: "all 0.3s ease",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 8px 20px rgba(243, 156, 18, 0.3)",
  },
  arrowIcon: {
    fontSize: "0.9rem",
  },
};

// Hover effects can be added via CSS:
/*
  .why-choose-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 30px rgba(0,0,0,0.05);
    border-color: #f39c1240;
  }
  .why-choose-card:hover .why-choose-icon {
    background-color: #f39c12;
    color: #ffffff;
  }
  .why-choose-button:hover {
    background-color: #e07c0c;
    transform: translateY(-2px);
    box-shadow: 0 12px 25px rgba(243, 156, 18, 0.4);
  }
  .why-choose-button:hover .arrow-icon {
    transform: translateX(4px);
  }
*/

export default WhyChooseUs;
